export default __webpack_public_path__ + "static/media/carpaccio.ebd06fa8.jpg";